import { breadcrumbsForPath } from "@/lib/seo/breadcrumbs";
import { absoluteUrl, breadcrumbList, collectionPage, faqPage, webPage } from "@/lib/seo/schema";
import type { BreadcrumbItem, FaqEntry, JsonLdNode, ListedItem } from "@/lib/seo/schema";

export const pageGraph = ({
  path,
  name,
  description,
  crumbs,
  faqs,
  extra,
  mainEntity,
  speakable,
  inLanguage,
}: {
  path: string;
  name: string;
  description: string;
  crumbs?: BreadcrumbItem[];
  faqs?: FaqEntry[];
  extra?: JsonLdNode[];
  mainEntity?: JsonLdNode;
  speakable?: string[];
  inLanguage?: string;
}): JsonLdNode[] => {
  const trail = crumbs ?? breadcrumbsForPath(path);
  const base = absoluteUrl(path);
  const breadcrumbId = `${base}#breadcrumb`;
  const hasTrail = trail.length > 1;

  return [
    {
      "@id": `${base}#webpage`,
      ...webPage({ url: path, name, description, inLanguage }),
      ...(hasTrail ? { breadcrumb: { "@id": breadcrumbId } } : {}),
      ...(mainEntity ? { mainEntity } : {}),
      ...(speakable?.length
        ? { speakable: { "@type": "SpeakableSpecification", cssSelector: speakable } }
        : {}),
    },
    ...(hasTrail ? [{ "@id": breadcrumbId, ...breadcrumbList(trail) }] : []),
    ...(faqs?.length ? [faqPage(faqs)] : []),
    ...(extra ?? []),
  ];
};

export const hubGraph = ({
  path,
  name,
  description,
  items,
  faqs,
}: {
  path: string;
  name: string;
  description: string;
  items: ListedItem[];
  faqs?: FaqEntry[];
}): JsonLdNode[] => {
  const trail = breadcrumbsForPath(path);
  const base = absoluteUrl(path);
  const breadcrumbId = `${base}#breadcrumb`;
  const hasTrail = trail.length > 1;

  return [
    {
      "@id": `${base}#webpage`,
      ...collectionPage({ url: path, name, description, items }),
      ...(hasTrail ? { breadcrumb: { "@id": breadcrumbId } } : {}),
    },
    ...(hasTrail ? [{ "@id": breadcrumbId, ...breadcrumbList(trail) }] : []),
    ...(faqs?.length ? [faqPage(faqs)] : []),
  ];
};
